import React from 'react';
import './App.css'
import Form from './Components/Layout/Form';

function App() {
  return (
    <div className='App'>   
      <section className='form-section'>
        <Form/>
      </section>
    </div>
  );
}

export default App;
